<app-componente-cad-usuario (onChangeAba)="irParaExecutoresEBeneficiarios()" [TodosCampos]="true"></app-componente-cad-usuario>
